<template>
    <div class="footer">
        <router-link to="/tos" @click.native="scrollTop">Terms of Service</router-link>
        | <router-link to="/privacy" @click.native="scrollTop">Privacy Policy</router-link>
        | <router-link to="/support" @click.native="scrollTop">Support</router-link>
        <br><br>
        <div>Cheese icon by <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">Smashicons</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>
    </div>
</template>

<script>
export default {
    methods: {
        scrollTop: function(){
            document.querySelector(".md-app-scroller").scrollTo(0,0)
        }
    }
}
</script>

